import { GradeDetailsPageContent } from "@app/grades/pages";
import { getGradeService } from "@core/grades/services";
import { type GradeWithCategories } from "@core/grades/types";
import { getRootSettings, pageHead } from "@framework/config/drivers/meta";
import { publicRoutes } from "@framework/middleware";
import { plainTrans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export const loader = publicRoutes(async ({ params, http, success }) => {
  const { id } = params;

  const { grade } = await getGradeService(http, id!);

  return success({ grade });
});

export default function GradeDetails() {
  const { grade } = useLoaderData<{ grade: GradeWithCategories }>();

  return <GradeDetailsPageContent grade={grade} />;
}

export const meta: MetaFunction<typeof loader> = ({ data, matches }) => {
  const settings = getRootSettings(matches);
  // `data` is null when the loader threw, or lacks `grade` on a failed request.
  const gradeName = (data as any)?.grade?.name || "";

  return pageHead({
    title: `${gradeName} - ${settings.general?.appName || ""}`,
    description: plainTrans("grades.gradeDescription", { grade: gradeName }),
    image: settings.general?.logo?.url || "",
    settings,
  });
};
